import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Store } from "../Store";

export default function ProtectedRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;
  return userInfo && userInfo.isAdmin ? children : <Navigate to="/login" />;
}
